export function postingAge(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d)) return null;
  const days = Math.floor((Date.now() - d.getTime()) / 86400000);
  if (days <= 0) return "Publié aujourd'hui";
  if (days === 1) return "Publié hier";
  if (days < 7) return `Publié il y a ${days} jours`;
  if (days < 14) return "Publié il y a 1 semaine";
  if (days < 30) return `Publié il y a ${Math.floor(days / 7)} semaines`;
  return `Publié il y a ${Math.floor(days / 30)} mois`;
}

export function remoteLabel(v) {
  if (!v) return null;
  const s = String(v).toLowerCase();
  if (s.includes("remote") || s.includes("télé") || s.includes("tele")) return "Remote";
  if (s.includes("hybr")) return "Hybride";
  if (s.includes("site") || s.includes("onsite") || s.includes("présent")) return "Sur site";
  return v;
}

// Rémunération : TJM (tarif journalier, salary_period="day") ou salaire annuel (autres sources).
export function salaryLabel(o) {
  if (!o) return null;
  const num = (v) => {
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
  };
  const min = num(o.salary_min);
  const max = num(o.salary_max);
  if (min == null && max == null) return null;
  const period = String(o.salary_period || "").toLowerCase();
  const cur = !o.salary_currency || o.salary_currency === "EUR" ? "€" : o.salary_currency;
  if (period === "day") {
    const range = min && max && min !== max ? `${min}-${max}` : `${min || max}`;
    return { label: `TJM ${range} ${cur}/j`, kind: "tjm" };
  }
  const k = (v) => (v >= 1000 ? `${Math.round(v / 1000)}k` : `${v}`);
  const big = (min || 0) >= 1000 || (max || 0) >= 1000;
  const range = min && max && min !== max ? `${k(min)}-${k(max)}` : `${k(min || max)}`;
  const suffix = period === "month" ? `${cur}/mois` : `${cur}${big ? "/an" : ""}`;
  return { label: `${range} ${suffix}`, kind: "salary" };
}

// Type de relation entreprise : "Client Final" (client final) vs "ESN" (intermédiaire).
export function clientTypeMeta(ct) {
  if (ct === "intermediary") {
    return { key: "intermediary", label: "ESN", color: "#F59E0B" };
  }
  return { key: "end_client", label: "Client Final", color: "#22C55E" };
}

// Classification 4 valeurs de l'entreprise émettrice (badge visible sur les résultats).
export function companyClassMeta(cls) {
  switch (cls) {
    case "FINAL_CLIENT":
      return { key: "FINAL_CLIENT", label: "Client final", color: "#22C55E" };
    case "ESN_CONSULTING":
      return { key: "ESN_CONSULTING", label: "ESN / Cabinet", color: "#F59E0B" };
    case "STAFFING_RECRUITMENT":
      return { key: "STAFFING_RECRUITMENT", label: "Intermédiaire", color: "#FB7185" };
    default:
      return { key: "UNKNOWN", label: "À confirmer", color: "#94A3B8" };
  }
}

// TJM structuré (item.tjm = {min, max, currency, unit:"day"}) -> libellé court.
export function tjmLabel(tjm) {
  if (!tjm) return null;
  const cur = !tjm.currency || tjm.currency === "EUR" ? "€" : tjm.currency;
  const lo = tjm.min;
  const hi = tjm.max || tjm.min;
  if (lo == null) return null;
  const range = lo && hi && lo !== hi ? `${lo}-${hi}` : `${lo || hi}`;
  return `TJM ${range} ${cur}/j`;
}

// Copies text to the clipboard with a fallback for non-secure contexts / blocked Clipboard API.
export async function copyToClipboard(text) {
  const value = String(text ?? "");
  if (!value) return false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch { /* fall through to legacy path */ }
  try {
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
